import type { LoaderFunctionArgs } from 'react-router';

import { legalSlugSchema } from '@boc/legal';

import { Route } from './+types/legal';

import { getContent } from '#/legal';

export const loader = ({ params }: LoaderFunctionArgs) => {
  // Validate the slug
  const result = legalSlugSchema.safeParse(params.slug);

  if (!result.success) {
    throw new Response('Not Found', { status: 404 });
  }

  return { slug: result.data, channel: params.channel ?? 'in' };
};

export default function LegalPage({ loaderData }: Route.ComponentProps) {
  const { slug, channel } = loaderData;
  const content = getContent(channel)[slug];

  if (!content) {
    throw new Response('Not Found', { status: 404 });
  }

  return content;
}
